<template>
  <div
    data-qa="appointment-restrictions-modal-content"
    class="d-flex flex-column overflow-y-hidden"
  >
    <div
      v-if="lpuName"
      class="d-flex align-center py-1 mb-4"
      data-qa="modal-content-lpu"
    >
      <v-icon
        class="mr-4"
        color="icon-secondary"
      >
        ui-icon-clinic
      </v-icon>
      <span
        class="text-body-1 text-break text--text"
      >{{ lpuName }}</span>
    </div>
    <div
      ref="restrictionsDataListRef"
      data-qa="modal-content-restrictions-data-list"
      class="custom-scroll overflow-y-auto text--text"
    >
      <div
        v-for="({ title, restrictions }, index) in restrictionsDataList"
        :key="index"
        data-qa="modal-content-restrictions-data-list-item"
        :class="{ 'mt-4': index !== 0 }"
      >
        <div
          data-qa="modal-content-restrictions-data-list-item-title"
          class="text-subtitle-1 text-break mb-1"
        >
          {{ title }}
        </div>
        <ul data-qa="modal-content-restrictions-data-list-item-restrictions">
          <li
            v-for="(restriction, indexRestriction) in restrictions"
            :key="indexRestriction"
            class="text-body-1 text-break"
            data-qa="modal-content-restrictions-data-list-item-restrictions-item"
          >
            {{ restriction }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import type { RestrictionsData } from 'www/vue_components/common/AppointmentRestrictions/types'

const props = defineProps<{
  isOpened: boolean
  lpuName: string | undefined
  restrictionsDataList: RestrictionsData[]
}>()

const restrictionsDataListRef = ref<HTMLElement>()

watch(() => props.isOpened, value => {
  if (value && restrictionsDataListRef.value) {
    restrictionsDataListRef.value.scrollTop = 0
  }
}, { immediate: true })
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/mixins';

.custom-scroll {
  @include custom-scroll;
}
</style>
